import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { STATIC_TRANSLATION_TOKEN } from '../../schema/injection-token';
import { IStaticTranslationsProxy, StaticTranslation } from '../../schema/interfaces/static-translation-proxy';
import { LanguageService } from '../language/language.service';

@Injectable()
export class StaticTranslationsService {
  constructor(
    @Inject(STATIC_TRANSLATION_TOKEN)
    private staticTranslations: IStaticTranslationsProxy,
    private language: LanguageService,
    private translate: TranslateService
  ) {}

  loadLocalTranslations(): Observable<boolean> {
    return this.language.getLanguage().pipe(
      map(lang => {
        const i18n = require(`src/assets/i18n/${lang}.json`);
        return this.store(lang, i18n);
      })
    );
  }

  loadStaticTranslations(): Observable<boolean> {
    return this.language.getLanguage().pipe(switchMap(lang => this.fetchTranslations(lang)));
  }

  protected fetchTranslations(lang: string): Observable<boolean> {
    return this.staticTranslations.setup(lang).pipe(map(staticTranslation => this.parse(lang, staticTranslation)));
  }

  protected parse(lang: string, staticTranslation: StaticTranslation, shouldMerge: boolean = true): boolean {
    const translations = {};
    (staticTranslation[lang] || []).forEach(translation => (translations[translation.Key] = translation.Text));
    this.translate.setTranslation(lang, translations, shouldMerge);
    this.translate.use(lang);
    return true;
  }

  protected store(lang: string, translations: Object, shouldMerge: boolean = true): boolean {
    if (translations) {
      this.translate.setTranslation(lang, translations, shouldMerge);
      this.translate.use(lang);
      return true;
    }
    return false;
  }
}
